const CODE_VERIFIER_KEY = 'pkceCodeVerifier';

// RFC 7636 allows 43-128 characters; 32 random bytes base64url-encoded gives 43.
const VERIFIER_BYTE_LENGTH = 32;

export const CODE_CHALLENGE_METHOD = 'S256';

const base64UrlEncode = (bytes: Uint8Array) =>
    btoa(String.fromCharCode(...bytes))
        .replace(/\+/g, '-')
        .replace(/\//g, '_')
        .replace(/=+$/, '');

export const generateCodeVerifier = () =>
    base64UrlEncode(crypto.getRandomValues(new Uint8Array(VERIFIER_BYTE_LENGTH)));

export const createCodeChallenge = async (codeVerifier: string) => {
    const digest = await crypto.subtle.digest('SHA-256', new TextEncoder().encode(codeVerifier));

    return base64UrlEncode(new Uint8Array(digest));
};

// The verifier has to survive the redirect to the identity provider, but must
// not outlive the browser session, hence sessionStorage.
const storeCodeVerifier = (codeVerifier: string) =>
    sessionStorage.setItem(CODE_VERIFIER_KEY, codeVerifier);

export const readCodeVerifier = () => sessionStorage.getItem(CODE_VERIFIER_KEY);

export const clearCodeVerifier = () => sessionStorage.removeItem(CODE_VERIFIER_KEY);

/**
 * Creates a fresh PKCE verifier/challenge pair and persists the verifier so it
 * can be sent along with the authorization code on the /oauth/token request.
 */
export const preparePkceChallenge = () => {
    const codeVerifier = generateCodeVerifier();

    storeCodeVerifier(codeVerifier);

    return createCodeChallenge(codeVerifier);
};
